import { MessageMedium } from 'constants/messageMediums';
import { useTemplatesPreviewQuery } from 'modules/ai/hooks/campaigns';
import { IMAGE_PREVIEW_MEDIUMS } from 'modules/campaigns/lib/components/CampaignPreviewThumbnail';
import { TEMPLATE_THUMBNAIL_QUERY_KEY } from '../ActivityFeed/ActivityItem.constants';

interface UseGetTemplateThumbnailDataProps {
  templateId: number;
  messageMedium: string;
}

export const useGetTemplateThumbnailData = ({
  templateId,
  messageMedium,
}: UseGetTemplateThumbnailDataProps) => {
  const templateIds = templateId ? [templateId] : [];
  const { isLoading: isThumbnailLoading, data: previewThumbnailsByIdData } =
    useTemplatesPreviewQuery(
      IMAGE_PREVIEW_MEDIUMS.includes(messageMedium as MessageMedium),
      templateIds,
      TEMPLATE_THUMBNAIL_QUERY_KEY,
    );
  const thumbnail = previewThumbnailsByIdData?.[templateId];

  return {
    thumbnail,
    isThumbnailLoading,
  };
};
